import React from 'react';
import PropTypes from 'prop-types';

export default class PlanesListItem extends React.Component {

  render = () => {

    const { cantidadCuotas, importe } = this.props;

      return (
          <div className="list-group-item hover-background-color">
              <div className="row justify-content-between align-items-center">
                  <div className="col-auto"> 
                      <small className="font-14 applyFont" style={{ whiteSpace: 'nowrap' }}>{"Prot. Ext " + cantidadCuotas + " meses + Prot Max"}</small>
                  </div>
                  <div className="col-auto"> 
                      <small className="font-14 applyFont d-inline-block">{importe.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</small>
                  </div>
              </div>
          </div>
      ); 
  }
}
PlanesListItem.propTypes = {
  cantidadCuotas: PropTypes.number,
  importe: PropTypes.number
}